import React from "react";
import { ISCRIZIONE } from "../../data/content";
import { scrollToId as scrollTo } from "../../lib/scroll";
import Reveal from "./Reveal";

export const ComeIscriversi = () => (
  <section id="iscriversi" data-testid="iscriversi-section" className="bg-cream py-20 md:py-32">
    <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12">
      <div className="mb-14 max-w-3xl">
        <p className="font-sub uppercase tracking-[0.3em] text-court font-bold text-sm mb-4">
          Come Iscriversi
        </p>
        <h2 className="font-heading uppercase leading-[0.9] text-navy text-4xl md:text-6xl tracking-tight">
          Tre passi per entrare in squadra
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {ISCRIZIONE.map((step, i) => (
          <Reveal key={step.n} delay={0.08 * i}>
            <div
              data-testid={`step-${step.n}`}
              className="bg-white border border-navy p-8 h-full hover:shadow-hard-orange hover:-translate-y-1 transition-all duration-300"
            >
              <div className="font-heading text-7xl md:text-8xl text-court leading-none">{step.n}</div>
              <h3 className="font-sub uppercase font-bold text-xl tracking-wide text-navy mt-4">{step.t}</h3>
              <p className="font-body text-navy/65 mt-3 leading-relaxed">{step.d}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-14 bg-navy text-white p-8 md:p-12 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div>
            <h3 className="font-heading uppercase text-3xl md:text-4xl text-gold">Pronto a scendere in campo?</h3>
            <p className="font-body text-white/70 mt-2">Prima settimana di prova sempre gratuita.</p>
          </div>
          <button
            data-testid="iscriversi-cta"
            onClick={() => scrollTo("contatti")}
            className="bg-court text-white rounded-none px-8 py-4 font-sub font-bold uppercase tracking-widest hover:bg-royal transition-colors duration-300 whitespace-nowrap"
          >
            Contattaci ora
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);

export default ComeIscriversi;
